import hipaaBadge from "@/assets/compliance/hipaa-badge.webp";
import gdprBadge from "@/assets/compliance/gdpr-badge.webp";
import pciBadge from "@/assets/compliance/pci-badge.webp";
import popiBadge from "@/assets/compliance/popi-badge.webp";

const complianceItems = [
{
  icon: hipaaBadge,
  title: "HIPAA Compliance",
  size: 80,
  desc: "Our operations align with HIPAA requirements, allowing us to support healthcare organisations and regulated environments where strict confidentiality and secure data handling are critical."
},
{
  icon: gdprBadge,
  title: "GDPR Compliance",
  size: 80,
  desc: "We follow GDPR principles to ensure personal data is processed lawfully, transparently and securely across all relevant operations."
},
{
  icon: pciBadge,
  title: "PCI Compliance",
  size: 64,
  desc: "Our processes align with PCI DSS standards, ensuring secure handling of payment card data and protecting sensitive financial information across all operations."
},
{
  icon: popiBadge,
  title: "POPI Compliance",
  size: 68,
  desc: "We adhere to South Africa's Protection of Personal Information Act, ensuring all personal data is collected, processed and stored responsibly and in accordance with local data protection legislation."
}];


export function ComplianceSection() {
  return (
    <section className="section-default bg-muted">
      <div className="container-main text-center">
        <span className="section-label">Security</span>
        <h2 className="text-3xl md:text-4xl font-bold text-primary uppercase mb-10">
          Built on Trust & Compliance
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {complianceItems.map((item, i) => (
            <div key={i} className="card-elevated p-8 text-center flex flex-col">
              <div className="flex items-center justify-center h-[80px] mb-4">
                <img src={item.icon} alt={item.title} style={{ height: item.size, width: item.size }} className="object-contain" />
              </div>
              <h3 className="text-lg font-bold text-foreground mb-2">{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}